import { useEffect } from 'react';

const tabableSelector = 'a[href], area[href], input:not([disabled]), '
  + 'button:not([disabled]),select:not([disabled]), textarea:not([disabled]), '
  + 'iframe, object, embed, *[tabindex]:not([tabindex^="-"]), *[contenteditable=true]';

const useTrapFocus = (
  elementRef: React.RefObject<HTMLDivElement>,
  enabled: boolean = true,
) => {
  useEffect(() => {
    if (!enabled) return undefined;

    // Trap the focus within the provided container element.
    const element = elementRef.current;
    if (!element) return undefined;

    const firstFocusable = element?.querySelector(tabableSelector);
    (firstFocusable as HTMLElement)?.focus();

    const trapFocus = (e) => {
      const focusableEls = element?.querySelectorAll(tabableSelector);
      if (!focusableEls.length) return;

      const firstEl = focusableEls[0];
      const lastEl = focusableEls[focusableEls.length - 1];

      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === firstEl) {
            e.preventDefault();
            (lastEl as HTMLElement)?.focus();
          }
        } else if (document.activeElement === lastEl) {
          e.preventDefault();
          (firstEl as HTMLElement)?.focus();
        }
      }
    };

    document.addEventListener('keydown', trapFocus);
    return () => document.removeEventListener('keydown', trapFocus);
  }, [enabled, elementRef]);
};

export default useTrapFocus;
